module.exports = __webpack_public_path__ + "img/banner3_1_jp.5bc70000.png";